module.exports = __webpack_public_path__ + "static/media/il.874270d6.svg";